/**
 * Route-level wrapper for /ai-exam.
 * Registration/AuthGate removed from gate flow. AI exam accessible for free (1 after 3 tests) and subscribed users.
 */

import React from 'react';
import AIExam from './AIExam';

export function AIExamGuard() {
  return <AIExam />;
}
